// import React, { useState, useEffect } from "react";
// import apiService from "../config";
// import { useLanguage } from "../StoreContext/LanguageContext";
// import { useNavigate } from "react-router-dom";

// // All fields used in formRows - only these are sent in API payload
// const FORM_ROW_FIELDS = [
//   "acquisition_incharge_name",
//   "acquisition_incharge_designation",
//   "acquisition_incharge_address",
//   "dist_name",
//   "taluka_name",
//   "village_name",
//   "acquisition_regional_incharge_name",
//   "acquisition_regional_incharge_designation",
//   "acquisition_regional_incharge_address",
//   "acquisition_regional_incharge_contact",
//   "acquisition_regional_incharge_office_contact",
//   "acquisition_regional_incharge_email",
// ];

// // formRows configuration
// const formRows = [
//   {
//     question: "भूसंपादन प्रस्ताव पाठविणाऱ्या अधिका-याचे नाव",
//     type: "multiple_fields",
//     fields: [
//       {
//         label: "नाव",
//         fieldName: "acquisition_incharge_name",
//         type: "text",
//         placeholder: "अधिकाऱ्याचे पूर्ण नाव प्रविष्ट करा",
//         required: true,
//       },
//       {
//         label: "पदनाम/संपादन संस्थेचे नाव",
//         fieldName: "acquisition_incharge_designation",
//         type: "text",
//         placeholder: "पदनाम प्रविष्ट करा",
//         required: true,
//       },
//       {
//         label: "पत्ता",
//         fieldName: "acquisition_incharge_address",
//         type: "text",
//         placeholder: "पत्ता प्रविष्ट करा",
//         required: true,
//       },
//     ],
//   },
//   {
//     question: "संपादन करावयाच्या जमिनी ज्या क्षेत्रात मोडतात ते गाव, तालुका, जिल्हा.",
//     type: "multiple_dropdowns",
//     fields: [
//       { label: "जिल्हा", fieldName: "dist_name", type: "district_dropdown", required: true },
//       { label: "तालुका", fieldName: "taluka_name", type: "taluka_dropdown", required: true },
//       { label: "गाव", fieldName: "village_name", type: "village_dropdown", required: true },
//     ],
//   },
//   {
//     question: "प्रादेशिक विभाग/प्राधिकरण / महामंडळाच्या प्राधिकृत अधिकाऱ्याचा तपशील",
//     type: "multiple_fields",
//     fields: [
//       {
//         label: "नाव (Name)",
//         fieldName: "acquisition_regional_incharge_name",
//         type: "text",
//         placeholder: "अधिकाऱ्याचे नाव प्रविष्ट करा",
//         required: true,
//       },
//       {
//         label: "पदनाम (Designation)",
//         fieldName: "acquisition_regional_incharge_designation",
//         type: "text",
//         placeholder: "पदनाम प्रविष्ट करा",
//         required: true,
//       },
//       {
//         label: "पत्ता (Address)",
//         fieldName: "acquisition_regional_incharge_address",
//         type: "text",
//         placeholder: "पत्ता प्रविष्ट करा",
//         required: true,
//       },
//       {
//         label: "भ्रमणध्वनी (Cell Phone)",
//         fieldName: "acquisition_regional_incharge_contact",
//         type: "number",
//         placeholder: "मोबाईल नंबर प्रविष्ट करा",
//         inputMode: "numeric",
//         required: false,
//       },
//       {
//         label: "कार्यालयीन दुरध्वनी (Office Phone)",
//         fieldName: "acquisition_regional_incharge_office_contact",
//         type: "number",
//         placeholder: "कार्यालयीन नंबर प्रविष्ट करा",
//         inputMode: "numeric",
//         required: false,
//       },
//       {
//         label: "ईमेल (email-id)",
//         fieldName: "acquisition_regional_incharge_email",
//         type: "email",
//         placeholder: "ईमेल पत्ता प्रविष्ट करा",
//         required: false,
//       },
//     ],
//   },
// ];

// const NamunaK = ({ setSubComponent, setSelectedComponent }) => {
//   const { language, translations } = useLanguage();
//   const navigate = useNavigate();

//   // Form state
//   const [formData, setFormData] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);
//   const [fieldErrors, setFieldErrors] = useState({});

//   // Project info
//   const [currentProjectId, setCurrentProjectId] = useState(null);
//   const [ProjectName, SetProjectName] = useState(null);

//   // Proposal info
//   const [proposalData, setProposalData] = useState({
//     proposalName: "",
//     proposalDate: "",
//   });

//   // Location dropdowns
//   const [districts, setDistricts] = useState([]);
//   const [talukas, setTalukas] = useState([]);
//   const [villages, setVillages] = useState([]);
//   const [loadingDistricts, setLoadingDistricts] = useState(false);
//   const [loadingTalukas, setLoadingTalukas] = useState(false);
//   const [loadingVillages, setLoadingVillages] = useState(false);

//   // ─── Get project info from localStorage ───────────────────────────────────
//   useEffect(() => {
//     const getProjectInfo = () => {
//       const selectedProject = localStorage.getItem("selectedProject");
//       if (selectedProject) {
//         try {
//           const project = JSON.parse(selectedProject);
//           return {
//             id: project.project_id || project.id,
//             name: project.project_name || project.name,
//           };
//         } catch (e) {
//           console.error("Error parsing selectedProject:", e);
//         }
//       }
//       const userData = localStorage.getItem("userData");
//       if (userData) {
//         try {
//           const user = JSON.parse(userData);
//           return {
//             id: user.data?.project_id || user.project_id,
//             name: user.data?.project_name || user.project_name,
//           };
//         } catch (e) {
//           console.error("Error parsing userData:", e);
//         }
//       }
//       return { id: null, name: null };
//     };

//     const projectInfo = getProjectInfo();
//     setCurrentProjectId(projectInfo.id);
//     SetProjectName(projectInfo.name);
//   }, []);

//   // ─── Load districts on mount ───────────────────────────────────────────────
//   useEffect(() => {
//     loadDistricts();
//   }, []);

//   const loadDistricts = async () => {
//     setLoadingDistricts(true);
//     try {
//       const response = await apiService.getDistricts();
//       if (response?.status === 200) setDistricts(response.data || []);
//     } catch (e) {
//       console.error("Error loading districts:", e);
//     } finally {
//       setLoadingDistricts(false);
//     }
//   };

//   const loadTalukas = async (districtName) => {
//     if (!districtName) { setTalukas([]); setVillages([]); return; }
//     setLoadingTalukas(true);
//     try {
//       const response = await apiService.getTalukas(districtName);
//       if (response?.status === 200) setTalukas(response.data || []);
//     } catch (e) {
//       console.error("Error loading talukas:", e);
//     } finally {
//       setLoadingTalukas(false);
//     }
//   };

//   const loadVillages = async (districtName, talukaName) => {
//     if (!districtName || !talukaName) { setVillages([]); return; }
//     setLoadingVillages(true);
//     try {
//       const response = await apiService.getVillages(districtName, talukaName);
//       if (response?.status === 200) setVillages(response.data || []);
//     } catch (e) {
//       console.error("Error loading villages:", e);
//     } finally {
//       setLoadingVillages(false);
//     }
//   };

//   // ─── Handlers ──────────────────────────────────────────────────────────────
//   const handleInputChange = (fieldName, value) => {
//     setFormData((prev) => ({ ...prev, [fieldName]: value }));
//     setFieldErrors((prev) => ({ ...prev, [fieldName]: null }));
//   };

//   const handleProposalInputChange = (fieldName, value) => {
//     setProposalData((prev) => ({ ...prev, [fieldName]: value }));
//     setFieldErrors((prev) => ({ ...prev, [fieldName]: null }));
//   };

//   const handleDistrictChange = (districtName) => {
//     setFormData((prev) => ({ ...prev, dist_name: districtName, taluka_name: "", village_name: "" }));
//     setTalukas([]);
//     setVillages([]);
//     setFieldErrors((prev) => ({ ...prev, dist_name: null }));
//     if (districtName) loadTalukas(districtName);
//   };

//   const handleTalukaChange = (talukaName) => {
//     setFormData((prev) => ({ ...prev, taluka_name: talukaName, village_name: "" }));
//     setVillages([]);
//     setFieldErrors((prev) => ({ ...prev, taluka_name: null }));
//     if (formData.dist_name && talukaName) loadVillages(formData.dist_name, talukaName);
//   };

//   const handleVillageChange = (villageName) => {
//     setFormData((prev) => ({ ...prev, village_name: villageName }));
//     setFieldErrors((prev) => ({ ...prev, village_name: null }));
//   };

//   // ─── Date utilities ────────────────────────────────────────────────────────
//   const formatDateForDatabase = (dateString) => {
//     if (!dateString) return "";
//     if (dateString.includes("-")) return dateString;
//     if (dateString.includes("/")) {
//       const [day, month, year] = dateString.split("/");
//       return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
//     }
//     return dateString;
//   };

//   const formatDateForDisplay = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const formatDateForInput = (dateString) => {
//     if (!dateString) return "";
//     const [day, month, year] = dateString.split("/");
//     return `${year}-${month}-${day}`;
//   };

//   // ─── Validation ────────────────────────────────────────────────────────────
//   const validateForm = () => {
//     const errors = {};

//     if (!proposalData.proposalName.trim()) errors.proposalName = "प्रस्ताव नाव आवश्यक आहे";
//     if (!proposalData.proposalDate) errors.proposalDate = "प्रस्ताव दिनांक आवश्यक आहे";

//     formRows.forEach((row) => {
//       if (row.type === "multiple_fields" || row.type === "multiple_dropdowns") {
//         row.fields.forEach((field) => {
//           if (field.required && !formData[field.fieldName]?.toString().trim()) {
//             errors[field.fieldName] = `${field.label} आवश्यक आहे`;
//           }
//         });
//       }
//     });

//     setFieldErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // ─── Submit ─────────────────────────────────────────────────────────────────
//   const handleCreateProposal = async () => {
//     setError(null);

//     if (!validateForm()) {
//       setError("कृपया सर्व आवश्यक फील्ड भरा");
//       return;
//     }

//     setSaving(true);
//     try {
//       const formDataToSend = new FormData();

//       FORM_ROW_FIELDS.forEach((key) => {
//         const value = formData[key];
//         if (value !== undefined && value !== null && value !== "") {
//           formDataToSend.append(key, value);
//         }
//       });

//       formDataToSend.append("acquisition_proposal_no", proposalData.proposalName);
//       formDataToSend.append("acquisition_proposal_date", formatDateForDatabase(proposalData.proposalDate));
//       formDataToSend.append("project_id", currentProjectId);
//       formDataToSend.append("isactive", 1);

//       const response = await apiService.postAddProposal(formDataToSend);

//       const isSuccess = [200, 201, 204].includes(response?.status);

//       if (isSuccess) {
//         // ✅ Step 1: selectedProposal mein acquisition_proposal_no update karo
//         // Navbar yahi key read karta hai currentProposal ke liye
//         const existingSelected = localStorage.getItem("selectedProposal");
//         let updatedProposal = {};
//         if (existingSelected) {
//           try { updatedProposal = JSON.parse(existingSelected); } catch (e) { }
//         }
//         updatedProposal.acquisition_proposal_no = proposalData.proposalName;
//         updatedProposal.acquisition_proposal_date = formatDateForDatabase(proposalData.proposalDate);
//         // localStorage.setItem("selectedProposal", JSON.stringify(updatedProposal));

//         // ✅ Step 2: selectedProposalNo set karo — ProposalInfo mein override ke liye
//         // Navbar reload ke baad yeh pehle dikhega, phir API aate hi remove ho jayega
//         // localStorage.setItem("selectedProposalNo", proposalData.proposalName);

//         // ✅ Step 3: currentProposalData bhi update karo agar exist karta hai
//         // const existingCurrentData = localStorage.getItem("currentProposalData");
//         // if (existingCurrentData) {
//         //   try {
//         //     const currentData = JSON.parse(existingCurrentData);
//         //     currentData.acquisition_proposal_no = proposalData.proposalName;
//         //     // localStorage.setItem("currentProposalData", JSON.stringify(currentData));
//         //   } catch (e) { }
//         // }

//         alert("प्रस्ताव यशस्वीरीत्या जतन केला गेला");
//         window.location.reload();

//         // ✅ Step 4: Proposal page pe jao + forcefully reload karo
//         // Reload ke baad Navbar selectedProposal read karega → naya no dikh ta rahega
//         setSelectedComponent("Proposal");
//         setSubComponent("Proposal");
//       }
//     } catch (err) {
//       console.error("Save error:", err);
//       // setError("प्रस्ताव जतन करताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ─── Styles ────────────────────────────────────────────────────────────────
//   const inputStyle = (fieldName) => ({
//     width: "100%",
//     padding: "8px",
//     border: `1px solid ${fieldErrors[fieldName] ? "#e53935" : "#ccc"}`,
//     borderRadius: "4px",
//     fontSize: "13px",
//     outline: "none",
//     backgroundColor: "#fff",
//   });

//   const selectStyle = (fieldName) => ({
//     width: "100%",
//     padding: "8px",
//     border: `1px solid ${fieldErrors[fieldName] ? "#e53935" : "#ccc"}`,
//     borderRadius: "4px",
//     fontSize: "13px",
//     backgroundColor: "#fff",
//   });

//   const labelStyle = {
//     display: "block",
//     marginBottom: "4px",
//     fontSize: "12px",
//     fontWeight: "600",
//     color: "#333",
//   };

//   const errorTextStyle = {
//     color: "#e53935",
//     fontSize: "11px",
//     marginTop: "3px",
//   };

//   // ─── Render ────────────────────────────────────────────────────────────────
//   return (
//     <div
//       style={{
//         padding: "20px",
//         background: "#fff",
//         fontFamily: "Arial, sans-serif",
//         maxWidth: "800px",
//         margin: "0 auto",
//       }}
//     >
//       {/* Header */}
//       <div style={{ textAlign: "center", marginBottom: "20px" }}>
//         <h2 style={{ fontSize: "18px", fontWeight: "bold", color: "#000", margin: "0 0 4px 0" }}>
//           प्रस्ताव माहिती
//         </h2>
//         {/* <p style={{ fontSize: "12px", color: "#333", margin: 0 }}>
//           {ProjectName || ""} साठी खाजगी जमिनीच्या भूसंपादचा प्रस्ताव
//         </p> */}
//       </div>

//       {/* Global error */}
//       {error && (
//         <div
//           style={{
//             backgroundColor: "#ffebee",
//             color: "#c62828",
//             padding: "10px",
//             borderRadius: "4px",
//             marginBottom: "16px",
//             border: "1px solid #ef5350",
//             fontSize: "13px",
//           }}
//         >
//           {error}
//         </div>
//       )}

//       {/* Form */}
//       <div
//         style={{
//           border: "2px solid #2196F3",
//           borderRadius: "8px",
//           padding: "24px",
//           backgroundColor: "#f8f9fa",
//         }}
//       >
//         <div style={{ display: "grid", gap: "18px" }}>

//           {/* ── Proposal No ── */}
//           <div>
//             <label style={labelStyle}>
//               प्रस्ताव नाव  <span style={{ color: "red" }}>*</span>
//             </label>
//             <input
//               type="text"
//               value={proposalData.proposalName}
//               onChange={(e) => handleProposalInputChange("proposalName", e.target.value)}
//               style={inputStyle("proposalName")}
//               placeholder="प्रस्तावाचे क्रमांक प्रविष्ट करा"
//             />
//             {fieldErrors.proposalName && <p style={errorTextStyle}>{fieldErrors.proposalName}</p>}
//           </div>

//           {/* ── Proposal Date ── */}
//           <div>
//             <label style={labelStyle}>
//               प्रस्ताव दिनांक (Proposal Date) <span style={{ color: "red" }}>*</span>
//             </label>
//             <input
//               type="date"
//               value={formatDateForInput(proposalData.proposalDate)}
//               onChange={(e) => {
//                 const formatted = formatDateForDisplay(e.target.value);
//                 handleProposalInputChange("proposalDate", formatted);
//               }}
//               style={inputStyle("proposalDate")}
//             />
//             {proposalData.proposalDate && (
//               <small style={{ color: "#666", fontSize: "12px" }}>
//                 निवडलेली दिनांक: {proposalData.proposalDate}
//               </small>
//             )}
//             {fieldErrors.proposalDate && <p style={errorTextStyle}>{fieldErrors.proposalDate}</p>}
//           </div>

//           {/* ── Field Group 1: Officer Name / Designation / Address ── */}
//           <div style={{ borderTop: "1px solid #ddd", paddingTop: "14px" }}>
//             <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", fontSize: "13px" }}>
//               भूसंपादन प्रस्ताव पाठविणाऱ्या अधिका-याचे नाव
//             </label>
//             <div style={{ display: "grid", gap: "10px" }}>
//               {[
//                 { label: "नाव", field: "acquisition_incharge_name", placeholder: "अधिकाऱ्याचे पूर्ण नाव प्रविष्ट करा" },
//                 { label: "पदनाम/संपादन संस्थेचे नाव", field: "acquisition_incharge_designation", placeholder: "पदनाम प्रविष्ट करा" },
//                 { label: "पत्ता", field: "acquisition_incharge_address", placeholder: "पत्ता प्रविष्ट करा" },
//               ].map(({ label, field, placeholder }) => (
//                 <div key={field}>
//                   <label style={labelStyle}>
//                     {label} <span style={{ color: "red" }}>*</span>
//                   </label>
//                   <input
//                     type="text"
//                     value={formData[field] || ""}
//                     onChange={(e) => handleInputChange(field, e.target.value)}
//                     style={inputStyle(field)}
//                     placeholder={placeholder}
//                   />
//                   {fieldErrors[field] && <p style={errorTextStyle}>{fieldErrors[field]}</p>}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* ── Field Group 2: District / Taluka / Village ── */}
//           <div style={{ borderTop: "1px solid #ddd", paddingTop: "14px" }}>
//             <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", fontSize: "13px" }}>
//               संपादन करावयाच्या जमिनी ज्या क्षेत्रात मोडतात ते गाव, तालुका, जिल्हा{" "}
//               <span style={{ color: "red" }}>*</span>
//             </label>
//             <div style={{ display: "grid", gap: "10px" }}>

//               {/* District */}
//               <div>
//                 <label style={labelStyle}>
//                   जिल्हा <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   value={formData.dist_name || ""}
//                   onChange={(e) => handleDistrictChange(e.target.value)}
//                   disabled={loadingDistricts}
//                   style={selectStyle("dist_name")}
//                 >
//                   <option value="">{loadingDistricts ? "लोड होत आहे..." : "जिल्हा निवडा"}</option>
//                   {districts.map((d) => (
//                     <option key={d.dist_no} value={d.dist_name}>{d.dist_name}</option>
//                   ))}
//                 </select>
//                 {fieldErrors.dist_name && <p style={errorTextStyle}>{fieldErrors.dist_name}</p>}
//               </div>

//               {/* Taluka */}
//               <div>
//                 <label style={labelStyle}>
//                   तालुका <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   value={formData.taluka_name || ""}
//                   onChange={(e) => handleTalukaChange(e.target.value)}
//                   disabled={loadingTalukas || !formData.dist_name}
//                   style={selectStyle("taluka_name")}
//                 >
//                   <option value="">
//                     {!formData.dist_name ? "पहिले जिल्हा निवडा" : loadingTalukas ? "लोड होत आहे..." : "तालुका निवडा"}
//                   </option>
//                   {talukas.map((t) => (
//                     <option key={t.taluka_no} value={t.taluka_name}>{t.taluka_name}</option>
//                   ))}
//                 </select>
//                 {fieldErrors.taluka_name && <p style={errorTextStyle}>{fieldErrors.taluka_name}</p>}
//               </div>

//               {/* Village */}
//               <div>
//                 <label style={labelStyle}>
//                   गाव <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   value={formData.village_name || ""}
//                   onChange={(e) => handleVillageChange(e.target.value)}
//                   disabled={loadingVillages || !formData.dist_name || !formData.taluka_name}
//                   style={selectStyle("village_name")}
//                 >
//                   <option value="">
//                     {!formData.dist_name || !formData.taluka_name
//                       ? "पहिले जिल्हा आणि तालुका निवडा"
//                       : loadingVillages
//                         ? "लोड होत आहे..."
//                         : "गाव निवडा"}
//                   </option>
//                   {villages.map((v) => (
//                     <option key={v.village_id} value={v.village_name}>{v.village_name}</option>
//                   ))}
//                 </select>
//                 {fieldErrors.village_name && <p style={errorTextStyle}>{fieldErrors.village_name}</p>}
//               </div>

//             </div>
//           </div>

//           {/* ── Field Group 3: Regional Officer Details ── */}
//           <div style={{ borderTop: "1px solid #ddd", paddingTop: "14px" }}>
//             <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", fontSize: "13px" }}>
//               प्रादेशिक विभाग/प्राधिकरण / महामंडळाच्या प्राधिकृत अधिकाऱ्याचा तपशील
//             </label>
//             <div style={{ display: "grid", gap: "10px" }}>
//               {[
//                 { label: "नाव (Name)", field: "acquisition_regional_incharge_name", type: "text", placeholder: "अधिकाऱ्याचे नाव प्रविष्ट करा" },
//                 { label: "पदनाम (Designation)", field: "acquisition_regional_incharge_designation", type: "text", placeholder: "पदनाम प्रविष्ट करा" },
//                 { label: "पत्ता (Address)", field: "acquisition_regional_incharge_address", type: "text", placeholder: "पत्ता प्रविष्ट करा" },
//                 { label: "भ्रमणध्वनी (Cell Phone)", field: "acquisition_regional_incharge_contact", type: "number", placeholder: "मोबाईल नंबर प्रविष्ट करा", required: false },
//                 { label: "कार्यालयीन दुरध्वनी (Office Phone)", field: "acquisition_regional_incharge_office_contact", type: "number", placeholder: "कार्यालयीन नंबर प्रविष्ट करा", required: false },
//                 { label: "ईमेल (email-id)", field: "acquisition_regional_incharge_email", type: "email", placeholder: "ईमेल पत्ता प्रविष्ट करा", required: false },
//               ].map(({ label, field, type, placeholder, required = true }) => (
//                 <div key={field}>
//                   <label style={labelStyle}>
//                     {label} {required && <span style={{ color: "red" }}>*</span>}
//                   </label>
//                   <input
//                     type={type}
//                     value={formData[field] || ""}
//                     onChange={(e) => handleInputChange(field, e.target.value)}
//                     style={inputStyle(field)}
//                     placeholder={placeholder}
//                     inputMode={type === "number" ? "numeric" : undefined}
//                   />
//                   {fieldErrors[field] && <p style={errorTextStyle}>{fieldErrors[field]}</p>}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* ── Save Button ── */}
//           <button
//             onClick={handleCreateProposal}
//             disabled={saving}
//             style={{
//               backgroundColor: saving ? "#90caf9" : "#2196F3",
//               color: "white",
//               padding: "12px 24px",
//               border: "none",
//               borderRadius: "4px",
//               fontSize: "15px",
//               cursor: saving ? "not-allowed" : "pointer",
//               fontWeight: "bold",
//               marginTop: "8px",
//             }}
//           >
//             {saving ? "सेव्ह होत आहे..." : "सेव्ह करा"}
//           </button>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default NamunaK;

import React, { useState, useEffect } from "react";
import apiService from "../config";
import { useLanguage } from "../StoreContext/LanguageContext";
import { useNavigate } from "react-router-dom";

// Removed dist_name, taluka_name, village_name from here as they are handled separately now
const FORM_ROW_FIELDS = [
  "acquisition_incharge_name",
  "acquisition_incharge_designation",
  "acquisition_incharge_address",
  "acquisition_regional_incharge_name",
  "acquisition_regional_incharge_designation",
  "acquisition_regional_incharge_address",
  "acquisition_regional_incharge_contact",
  "acquisition_regional_incharge_office_contact",
  "acquisition_regional_incharge_email",
];

const NamunaK = ({ setSubComponent, setSelectedComponent }) => {
  const { language, translations } = useLanguage();
  const navigate = useNavigate();

  // Form state
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});

  // Dynamic Locations State
  const [locations, setLocations] = useState([
    { dist_name: "", taluka_name: "", village_name: "" },
  ]);

  // Project info
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [ProjectName, SetProjectName] = useState(null);

  // Proposal info
  const [proposalData, setProposalData] = useState({
    proposalName: "",
    proposalDate: "",
  });

  // Dropdown Caches to prevent duplicate API calls
  const [districts, setDistricts] = useState([]);
  const [talukasCache, setTalukasCache] = useState({});
  const [villagesCache, setVillagesCache] = useState({});
  const [loadingStates, setLoadingStates] = useState({ districts: false });

  // ─── Get project info from localStorage ───────────────────────────────────
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem("selectedProject");
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name,
          };
        } catch (e) {
          console.error("Error parsing selectedProject:", e);
        }
      }
      const userData = localStorage.getItem("userData");
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return {
            id: user.data?.project_id || user.project_id,
            name: user.data?.project_name || user.project_name,
          };
        } catch (e) {
          console.error("Error parsing userData:", e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
    SetProjectName(projectInfo.name);
  }, []);

  // ─── Load districts on mount ───────────────────────────────────────────────
  useEffect(() => {
    loadDistricts();
  }, []);

  const loadDistricts = async () => {
    setLoadingStates((prev) => ({ ...prev, districts: true }));
    try {
      const response = await apiService.getDistricts();
      if (response?.status === 200) setDistricts(response.data || []);
    } catch (e) {
      console.error("Error loading districts:", e);
    } finally {
      setLoadingStates((prev) => ({ ...prev, districts: false }));
    }
  };

  // ─── Handlers ──────────────────────────────────────────────────────────────
  const handleInputChange = (fieldName, value) => {
    setFormData((prev) => ({ ...prev, [fieldName]: value }));
    setFieldErrors((prev) => ({ ...prev, [fieldName]: null }));
  };

  const handleProposalInputChange = (fieldName, value) => {
    setProposalData((prev) => ({ ...prev, [fieldName]: value }));
    setFieldErrors((prev) => ({ ...prev, [fieldName]: null }));
  };

  // ─── Location Handlers ─────────────────────────────────────────────────────
  const handleAddLocation = () => {
    const lastLoc = locations[locations.length - 1];
    setLocations([
      ...locations,
      {
        dist_name: lastLoc.dist_name || "", // Auto-fill the district from previous row to save time
        taluka_name: "",
        village_name: "",
      },
    ]);
  };

  const handleRemoveLocation = (index) => {
    const updatedLocations = [...locations];
    updatedLocations.splice(index, 1);
    setLocations(updatedLocations);
  };

  const handleLocationChange = async (index, field, value) => {
    const newLocations = [...locations];
    newLocations[index][field] = value;

    // Reset dependent fields
    if (field === "dist_name") {
      newLocations[index].taluka_name = "";
      newLocations[index].village_name = "";
    } else if (field === "taluka_name") {
      newLocations[index].village_name = "";
    }

    setLocations(newLocations);
    setFieldErrors((prev) => ({ ...prev, [`location_${index}`]: null }));

    // Fetch Talukas if not in cache
    if (field === "dist_name" && value && !talukasCache[value]) {
      setLoadingStates((prev) => ({ ...prev, [`taluka_${value}`]: true }));
      try {
        const response = await apiService.getTalukas(value);
        if (response?.status === 200) {
          setTalukasCache((prev) => ({ ...prev, [value]: response.data || [] }));
        }
      } catch (e) {
        console.error("Error loading talukas:", e);
      } finally {
        setLoadingStates((prev) => ({ ...prev, [`taluka_${value}`]: false }));
      }
    }

    // Fetch Villages if not in cache
    if (field === "taluka_name" && value) {
      const distName = newLocations[index].dist_name;
      const cacheKey = `${distName}_${value}`;

      if (!villagesCache[cacheKey]) {
        setLoadingStates((prev) => ({ ...prev, [`village_${cacheKey}`]: true }));
        try {
          const response = await apiService.getVillages(distName, value);
          if (response?.status === 200) {
            setVillagesCache((prev) => ({ ...prev, [cacheKey]: response.data || [] }));
          }
        } catch (e) {
          console.error("Error loading villages:", e);
        } finally {
          setLoadingStates((prev) => ({ ...prev, [`village_${cacheKey}`]: false }));
        }
      }
    }
  };

  // ─── Date utilities ────────────────────────────────────────────────────────
  const formatDateForDatabase = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("-")) return dateString;
    if (dateString.includes("/")) {
      const [day, month, year] = dateString.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return dateString;
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  // ─── Validation ────────────────────────────────────────────────────────────
  const validateForm = () => {
    const errors = {};

    if (!proposalData.proposalName.trim()) errors.proposalName = "प्रस्ताव नाव आवश्यक आहे";
    if (!proposalData.proposalDate) errors.proposalDate = "प्रस्ताव दिनांक आवश्यक आहे";

    FORM_ROW_FIELDS.forEach((field) => {
      // Basic required validation (Assume all in FORM_ROW_FIELDS are required except contact/email)
      const nonRequiredFields = [
        "acquisition_regional_incharge_contact",
        "acquisition_regional_incharge_office_contact",
        "acquisition_regional_incharge_email"
      ];
      if (!nonRequiredFields.includes(field) && !formData[field]?.toString().trim()) {
        errors[field] = "हे क्षेत्र आवश्यक आहे";
      }
    });

    // Validate Locations
    let locationValid = true;
    locations.forEach((loc, idx) => {
      if (!loc.dist_name || !loc.taluka_name || !loc.village_name) {
        errors[`location_${idx}`] = "सर्व फील्ड भरणे आवश्यक आहे";
        locationValid = false;
      }
    });

    if (!locationValid) {
      errors.globalLocation = "कृपया सर्व जोडलेल्या गावाची माहिती पूर्ण भरा.";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ─── Submit ─────────────────────────────────────────────────────────────────
  const handleCreateProposal = async () => {
    setError(null);

    if (!validateForm()) {
      setError("कृपया सर्व आवश्यक फील्ड भरा");
      return;
    }

    setSaving(true);
    try {
      const formDataToSend = new FormData();

      FORM_ROW_FIELDS.forEach((key) => {
        const value = formData[key];
        if (value !== undefined && value !== null && value !== "") {
          formDataToSend.append(key, value);
        }
      });

      formDataToSend.append("acquisition_proposal_no", proposalData.proposalName);
      formDataToSend.append("acquisition_proposal_date", formatDateForDatabase(proposalData.proposalDate));
      formDataToSend.append("project_id", currentProjectId);
      formDataToSend.append("isactive", 1);

      // --- Append Dynamic Locations payload ---
      formDataToSend.append("location", JSON.stringify(locations));

      const response = await apiService.postAddProposal(formDataToSend);

      const isSuccess = [200, 201, 204].includes(response?.status);

      if (isSuccess) {
        alert("प्रस्ताव यशस्वीरीत्या जतन केला गेला");
        window.location.reload();
        setSelectedComponent("Proposal");
        setSubComponent("Proposal");
      }
    } catch (err) {
      console.error("Save error:", err);
      setError("प्रस्ताव जतन करताना त्रुटी आली. कृपया पुन्हा प्रयत्न करा.");
    } finally {
      setSaving(false);
    }
  };

  // ─── Styles ────────────────────────────────────────────────────────────────
  const inputStyle = (hasError) => ({
    width: "100%",
    padding: "8px",
    border: `1px solid ${hasError ? "#e53935" : "#ccc"}`,
    borderRadius: "4px",
    fontSize: "13px",
    outline: "none",
    backgroundColor: "#fff",
  });

  const selectStyle = (hasError) => ({
    width: "100%",
    padding: "8px",
    border: `1px solid ${hasError ? "#e53935" : "#ccc"}`,
    borderRadius: "4px",
    fontSize: "13px",
    backgroundColor: "#fff",
  });

  const labelStyle = {
    display: "block",
    marginBottom: "4px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#333",
  };

  const errorTextStyle = {
    color: "#e53935",
    fontSize: "11px",
    marginTop: "3px",
  };

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <div
      style={{
        padding: "20px",
        background: "#fff",
        fontFamily: "Arial, sans-serif",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2 style={{ fontSize: "18px", fontWeight: "bold", color: "#000", margin: "0 0 4px 0" }}>
          प्रस्ताव माहिती
        </h2>
      </div>

      {error && (
        <div style={{ backgroundColor: "#ffebee", color: "#c62828", padding: "10px", borderRadius: "4px", marginBottom: "16px", border: "1px solid #ef5350", fontSize: "13px" }}>
          {error}
        </div>
      )}

      <div style={{ border: "2px solid #2196F3", borderRadius: "8px", padding: "24px", backgroundColor: "#f8f9fa" }}>
        <div style={{ display: "grid", gap: "18px" }}>

          {/* ── Proposal No ── */}
          <div>
            <label style={labelStyle}>प्रस्ताव नाव <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              value={proposalData.proposalName}
              onChange={(e) => handleProposalInputChange("proposalName", e.target.value)}
              style={inputStyle(fieldErrors.proposalName)}
              placeholder="प्रस्ताव नाव प्रविष्ट करा"
            />
            {fieldErrors.proposalName && <p style={errorTextStyle}>{fieldErrors.proposalName}</p>}
          </div>

          {/* ── Proposal Date ── */}
          <div>
            <label style={labelStyle}>प्रस्ताव दिनांक (Proposal Date) <span style={{ color: "red" }}>*</span></label>
            <input
              type="date"
              value={formatDateForInput(proposalData.proposalDate)}
              onChange={(e) => {
                const formatted = formatDateForDisplay(e.target.value);
                handleProposalInputChange("proposalDate", formatted);
              }}
              style={inputStyle(fieldErrors.proposalDate)}
            />
            {fieldErrors.proposalDate && <p style={errorTextStyle}>{fieldErrors.proposalDate}</p>}
          </div>

          {/* ── Field Group 1: Officer Details ── */}
          <div style={{ borderTop: "1px solid #ddd", paddingTop: "14px" }}>
            <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", fontSize: "13px" }}>
              भूसंपादन प्रस्ताव पाठविणाऱ्या अधिका-याचे नाव
            </label>
            <div style={{ display: "grid", gap: "10px" }}>
              {[
                { label: "नाव", field: "acquisition_incharge_name", placeholder: "अधिकाऱ्याचे पूर्ण नाव प्रविष्ट करा" },
                { label: "पदनाम/संपादन संस्थेचे नाव", field: "acquisition_incharge_designation", placeholder: "पदनाम प्रविष्ट करा" },
                { label: "पत्ता", field: "acquisition_incharge_address", placeholder: "पत्ता प्रविष्ट करा" },
              ].map(({ label, field, placeholder }) => (
                <div key={field}>
                  <label style={labelStyle}>{label} <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    value={formData[field] || ""}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    style={inputStyle(fieldErrors[field])}
                    placeholder={placeholder}
                  />
                  {fieldErrors[field] && <p style={errorTextStyle}>{fieldErrors[field]}</p>}
                </div>
              ))}
            </div>
          </div>

          {/* ── Field Group 2: Dynamic District / Taluka / Village ── */}
          <div style={{ borderTop: "1px solid #ddd", paddingTop: "14px" }}>
            <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", fontSize: "13px" }}>
              संपादन करावयाच्या जमिनी ज्या क्षेत्रात मोडतात ते गाव, तालुका, जिल्हा <span style={{ color: "red" }}>*</span>
            </label>

            {fieldErrors.globalLocation && <p style={{...errorTextStyle, marginBottom: '10px'}}>{fieldErrors.globalLocation}</p>}

            {locations.map((loc, index) => {
              const rowTalukas = talukasCache[loc.dist_name] || [];
              const rowVillages = villagesCache[`${loc.dist_name}_${loc.taluka_name}`] || [];

              return (
                <div key={index} style={{ marginBottom: "15px", padding: "10px", backgroundColor: "#fff", border: `1px solid ${fieldErrors[`location_${index}`] ? "#e53935" : "#e0e0e0"}`, borderRadius: "6px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto", gap: "10px", alignItems: "end" }}>

                    {/* District */}
                    <div>
                      <label style={labelStyle}>जिल्हा</label>
                      <select
                        value={loc.dist_name}
                        onChange={(e) => handleLocationChange(index, "dist_name", e.target.value)}
                        disabled={loadingStates.districts}
                        style={selectStyle(fieldErrors[`location_${index}`])}
                      >
                        <option value="">{loadingStates.districts ? "लोड होत आहे..." : "जिल्हा निवडा"}</option>
                        {districts.map((d) => (
                          <option key={d.dist_no} value={d.dist_name}>{d.dist_name}</option>
                        ))}
                      </select>
                    </div>

                    {/* Taluka */}
                    <div>
                      <label style={labelStyle}>तालुका</label>
                      <select
                        value={loc.taluka_name}
                        onChange={(e) => handleLocationChange(index, "taluka_name", e.target.value)}
                        disabled={!loc.dist_name || loadingStates[`taluka_${loc.dist_name}`]}
                        style={selectStyle(fieldErrors[`location_${index}`])}
                      >
                        <option value="">{!loc.dist_name ? "पहिले जिल्हा निवडा" : loadingStates[`taluka_${loc.dist_name}`] ? "लोड होत आहे..." : "तालुका निवडा"}</option>
                        {rowTalukas.map((t) => (
                          <option key={t.taluka_no} value={t.taluka_name}>{t.taluka_name}</option>
                        ))}
                      </select>
                    </div>

                    {/* Village */}
                    <div>
                      <label style={labelStyle}>गाव</label>
                      <select
                        value={loc.village_name}
                        onChange={(e) => handleLocationChange(index, "village_name", e.target.value)}
                        disabled={!loc.taluka_name || loadingStates[`village_${loc.dist_name}_${loc.taluka_name}`]}
                        style={selectStyle(fieldErrors[`location_${index}`])}
                      >
                        <option value="">{!loc.taluka_name ? "पहिले तालुका निवडा" : loadingStates[`village_${loc.dist_name}_${loc.taluka_name}`] ? "लोड होत आहे..." : "गाव निवडा"}</option>
                        {rowVillages.map((v) => (
                          <option key={v.village_id} value={v.village_name}>{v.village_name}</option>
                        ))}
                      </select>
                    </div>

                    {/* Action Buttons */}
                    <div style={{ display: "flex", gap: "6px", height: "35px" }}>
                      <button
                        type="button"
                        onClick={handleAddLocation}
                        style={{ backgroundColor: "#4CAF50", color: "#fff", border: "none", borderRadius: "4px", width: "35px", cursor: "pointer", fontWeight: "bold" }}
                        title="Add Location"
                      >
                        +
                      </button>
                      {locations.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemoveLocation(index)}
                          style={{ backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px", width: "35px", cursor: "pointer", fontWeight: "bold" }}
                          title="Remove Location"
                        >
                          -
                        </button>
                      )}
                    </div>
                  </div>
                  {fieldErrors[`location_${index}`] && <p style={{...errorTextStyle, marginTop: "8px"}}>{fieldErrors[`location_${index}`]}</p>}
                </div>
              );
            })}
          </div>

          {/* ── Field Group 3: Regional Officer Details ── */}
          <div style={{ borderTop: "1px solid #ddd", paddingTop: "14px" }}>
            <label style={{ display: "block", marginBottom: "10px", fontWeight: "bold", fontSize: "13px" }}>
              प्रादेशिक विभाग/प्राधिकरण / महामंडळाच्या प्राधिकृत अधिकाऱ्याचा तपशील
            </label>
            <div style={{ display: "grid", gap: "10px" }}>
              {[
                { label: "नाव (Name)", field: "acquisition_regional_incharge_name", type: "text", placeholder: "अधिकाऱ्याचे नाव प्रविष्ट करा", required: true },
                { label: "पदनाम (Designation)", field: "acquisition_regional_incharge_designation", type: "text", placeholder: "पदनाम प्रविष्ट करा", required: true },
                { label: "पत्ता (Address)", field: "acquisition_regional_incharge_address", type: "text", placeholder: "पत्ता प्रविष्ट करा", required: true },
                { label: "भ्रमणध्वनी (Cell Phone)", field: "acquisition_regional_incharge_contact", type: "number", placeholder: "मोबाईल नंबर प्रविष्ट करा", required: false },
                { label: "कार्यालयीन दुरध्वनी (Office Phone)", field: "acquisition_regional_incharge_office_contact", type: "number", placeholder: "कार्यालयीन नंबर प्रविष्ट करा", required: false },
                { label: "ईमेल (email-id)", field: "acquisition_regional_incharge_email", type: "email", placeholder: "ईमेल पत्ता प्रविष्ट करा", required: false },
              ].map(({ label, field, type, placeholder, required }) => (
                <div key={field}>
                  <label style={labelStyle}>{label} {required && <span style={{ color: "red" }}>*</span>}</label>
                  <input
                    type={type}
                    value={formData[field] || ""}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    style={inputStyle(fieldErrors[field])}
                    placeholder={placeholder}
                    inputMode={type === "number" ? "numeric" : undefined}
                  />
                  {fieldErrors[field] && <p style={errorTextStyle}>{fieldErrors[field]}</p>}
                </div>
              ))}
            </div>
          </div>

          {/* ── Save Button ── */}
          <button
            onClick={handleCreateProposal}
            disabled={saving}
            style={{ backgroundColor: saving ? "#90caf9" : "#2196F3", color: "white", padding: "12px 24px", border: "none", borderRadius: "4px", fontSize: "15px", cursor: saving ? "not-allowed" : "pointer", fontWeight: "bold", marginTop: "8px" }}
          >
            {saving ? "सेव्ह होत आहे..." : "सेव्ह करा"}
          </button>

        </div>
      </div>
    </div>
  );
};

export default NamunaK;